import React from "react";
import { Div, Text3, CloseIcon } from "components/Base";

import { noop } from "utils/General";

const Header = ({ hideModal = noop, name = "", xSize = 24, height = null }) => {
  return (
    <Div
      style={{
        flexShrink: 0,
        borderBottom: "solid 1px #E7E6EA"
      }}
      display="row.space-between.center"
      bg="white"
      px={5}
      py={3}
      brt={1}
      bra={0}
      {...(height && { height })}
    >
      <Div>
        <Text3 style={{ wordWrap: "break-word" }} bold>
          {name}
        </Text3>
      </Div>
      <Div display="row.center.center" onClick={hideModal}>
        <CloseIcon color={"neutral7"} size={xSize} />
      </Div>
    </Div>
  );
};

export default Header;
